export default __webpack_public_path__ + "static/media/gourmand.3dd1ad77.png";